import { render, staticRenderFns } from "./_slug.vue?vue&type=template&id=8b3bf87c"
import script from "./_slug.vue?vue&type=script&setup=true&lang=js"
export * from "./_slug.vue?vue&type=script&setup=true&lang=js"
import style0 from "./_slug.vue?vue&type=style&index=0&id=8b3bf87c&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../../../../../work/modules/node_modules/@nuxt/webpack/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* nuxt-component-imports */
installComponents(component, {AppBreadcrumbs: require('/storage/data/jenkins/workspace/WEBPLATFORM/FRONTEND/PRESTIGIO-SOLUTIONS/PRESTIGIO-SOLUTIONS_Deploy_Prod@4/components/AppBreadcrumbs.vue').default,AppLeftSidebar: require('/storage/data/jenkins/workspace/WEBPLATFORM/FRONTEND/PRESTIGIO-SOLUTIONS/PRESTIGIO-SOLUTIONS_Deploy_Prod@4/components/AppLeftSidebar.vue').default,PageBlocks: require('/storage/data/jenkins/workspace/WEBPLATFORM/FRONTEND/PRESTIGIO-SOLUTIONS/PRESTIGIO-SOLUTIONS_Deploy_Prod@4/components/PageBlocks.vue').default})
